import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay/AutoplayEvents';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {CoinFlightEvents} from '@gongxigames/framework/slot/modules/buyBonus/coinFlight/CoinFlightEvents';
import {BuyBonusButtonView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonView';
import {BuyBonusButtonModule} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonModule';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {KeypadInfoElementsModule} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsModule';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';
import {BigWinModule} from '@gongxigames/framework/slot';

export class BuyBonusButtonBasicState extends ModuleState<BuyBonusButtonView, BuyBonusButtonModule> {
    public onEnterState(): void {
        this.onEnableButton();
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(AutoplayEvents.START_AUTOPLAY, this.onAutoPlayStarted.bind(this));
        this.setEventHandler(LogicEvents.SPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(CoinFlightEvents.COIN_FLIGHT_FINISHED, this.onEnableButton.bind(this));
        this.setEventHandler(KeypadControlsEvents.TOTAL_BET_CHANGED, this.onEnableButton.bind(this));
        this.setEventHandler('General.UI.BALANCE.UPDATED', this.onBalanceUpdated.bind(this));
    }

    protected onBalanceUpdated(): void {
        this.onEnableButton();
    }

    protected onReelsSpinningStarted(): void {
        this.module.disableByName(UIDisableReason.SPINNING);
    }

    protected onSpinResponseReceived(): void {
        if (this.module.logic.nextAction !== Action.SPIN) {
            this.onFeatureTriggered();
        } else if (this.isBigWinNext()) {
            this.module.disableByName(BigWinModule.NAME);
        }
    }

    protected onEnableButton(): void {
        const logic = this.module.logic;

        if (this.module.settings.get('ukRegulations')) {
            if (logic.isBonusCanBeBought()) {
                this.module.enableByName(KeypadInfoElementsModule.NAME);
            } else {
                this.module.disableByName(KeypadInfoElementsModule.NAME);
            }
        } else {
            if (this.module.disableReasons.length > 0) {
                return;
            }

            this.view.enableButton();
        }
    }

    protected onFeatureTriggered(): void {
        this.module.gotoState(BuyBonusButtonModule.FEATURE_STATE);
    }

    protected onAutoPlayStarted(): void {
        this.module.gotoState(BuyBonusButtonModule.AUTO_PLAY_STATE);
    }

    protected isBigWinNext(): boolean {
        return this.module.logic.getWin() >= this.module.logic.getBigWinLimit();
    }
}
